import {useSelector} from "react-redux";
import GoalComment from "./goal-comment";
import {
    normalizeMembershipEntity,
    prepareMembershipPayload,
} from "../workspace-membership/workspace-membership-identity";

const commentPopulate = {
    children: {
        populate: {
            user: {populate: {member: {populate: "profileImage"}}},
        },
    },
    user: {populate: {member: {populate: "profileImage"}}},
};

export function useGoalComment() {
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = workspaceMembership?.workspace?.workspace_memberships || [];

    const normalizeComment = (item) => {
        const normalized = normalizeMembershipEntity(item, "goalComment", memberships);
        if (!normalized) return normalized;
        normalized.children = (normalized.children || []).map((child) =>
            normalizeMembershipEntity(child, "goalComment", memberships));
        return normalized;
    };

    const getGoalComments = async (goalId)=>{
        try {
            const goalComment = new GoalComment();
            const query = {
                filters: {
                    $and:[
                        {goal:{$eq: goalId}},
                    ],
                },
                populate: commentPopulate,
            }
            const _data = await goalComment.getAll(query);

            return (_data.data || []).map(normalizeComment)
        }catch (e){
            throw e;
        }
    }

    const updateGoalComment = async (commentId, commentData)=>{
        try {
            const goalComment = new GoalComment();
            const payload = prepareMembershipPayload("goalComment", commentData, memberships, {
                currentMembership: workspaceMembership,
                operation: "update",
            });
            const _data = await goalComment.update(commentId, payload, {populate: commentPopulate});
            return normalizeComment(_data.data)
        }catch (e){
            throw e;
        }
    }

    const createGoalComment = async (commentData)=>{
        try {
            const goalComment = new GoalComment();
            const query = {populate: commentPopulate};
            const payload = prepareMembershipPayload("goalComment", commentData, memberships, {
                currentMembership: workspaceMembership,
                operation: "create",
            });
            const _data = await goalComment.create(payload, query);
            return normalizeComment(_data.data)
        }catch (e){
            throw e;
        }
    }

    const deleteGoalComment = async (commentId) => {
        const goalComment = new GoalComment();
        return goalComment.delete(commentId);
    };




    return {getGoalComments, updateGoalComment, createGoalComment, deleteGoalComment};
}
